import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '@/components/ui/tooltip';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import clsx from 'clsx';
import type React from 'react';

interface CustomTooltipProps {
	content: React.ReactNode;
	children: React.ReactNode;
	placement?: 'top' | 'right' | 'bottom' | 'left';
	align?: 'start' | 'center' | 'end';
	arrow?: boolean; // whether to show the arrow or not
	backgroundColor?: string;
	arrowColor?: string;
	delayDuration?: number; // delay duration for showing the tooltip
	borderColor?: string; //  border color for the tooltip
	textColor?: string; // text color for the tooltip
}

export const CustomTooltip = ({
	content,
	children,
	placement = 'top',
	align = 'center',
	backgroundColor = 'tw-bg-foreground/60', // Default background color
	arrowColor = 'tw-fill-foreground/60', // Default color for the arrow. Also make sure to set same color for color and arrowColor props.
	arrow = false,
	delayDuration = 0, // Default delay duration
	borderColor = 'tw-border-white', // Default border color
	textColor = 'tw-text-white', // Default text color - (white)
}: CustomTooltipProps) => {
	return (
		<TooltipProvider delayDuration={delayDuration}>
			<Tooltip>
				<TooltipTrigger asChild>{children}</TooltipTrigger>
				<TooltipContent
					side={placement}
					align={align}
					className={clsx(
						'tw-rounded tw-px-2 tw-py-1 tw-text-xl tw-shadow-md tw-border',
						backgroundColor,
						borderColor,
						textColor,
					)}
				>
					{content}
					{arrow && (
						<TooltipPrimitive.Arrow
							className={arrowColor}
							width={10}
							height={7}
							style={{
								stroke: borderColor, // fallback border
								strokeWidth: 1,
							}}
						/>
					)}
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	);
};
